import * as types from './mutation-types';
import api from '../../../../../configurations/service';
import { TPAG_CARTAO_CREDIT, TPAG_CARTAO_DEBIT, TPAG_PIX, NAME_ADMINISTRATION_STONE, TPAG_VOUCHERS } from '../../../enums/PaymentMode';

export const setZposConfigurated = async (context) => {
  const { data } = await api().post('fiscal.get-zpos-configuration');
  if (data.active) {
    context.commit(types.SET_ZPOS_CONFIGURATED, true);
  }
};

export const setZposIntegratorCollection = async (context) => {
  const { data } = await api().post('fiscal.get-zpos-integrators');
  if (data) {
    context.commit(types.SET_ZPOS_INTEGRATOR_COLLECTION, data);
  }
};

export const createZposTransaction = async (context, nfeId) => {
  const { data } = await api().post('fiscal.post-zpos-create-transaction', { nfeId });
  return data;
};

export const isIntegrator = (integrators, search) => {
  // eslint-disable-next-line array-callback-return, consistent-return
  const foundIntegrator = integrators.filter((e) => {
    if (e.description.toLowerCase().includes(search.toLowerCase())) return true;
  });

  if (foundIntegrator.length) return true;
  return false;
};

export const getUsedZpos = async (context, payload = {}) => {
  let used = true;
  if (!payload.zposConfigurated) used = false;

  const pagymentModeZpos = payload.paymentModeCollection.filter((e) => {
    if (e.cardAdministrator &&
      isIntegrator(payload.zposIntegratorCollection, e.cardAdministrator.description) &&
      [TPAG_CARTAO_DEBIT, TPAG_CARTAO_CREDIT, TPAG_PIX, ...TPAG_VOUCHERS].indexOf(e.paymentType.tPag) !== -1 &&
      !e.transactionNumber
    ) {
      return e;
    }
    return undefined;
  });

  if (pagymentModeZpos.some((e) => e.cardAdministrator.description === NAME_ADMINISTRATION_STONE) && !payload.isStoneInUseByZpos) used = false;

  if (!pagymentModeZpos.length) used = false;

  context.commit(types.SET_USED_ZPOS, used);
  return used;
};
